import {
  Component,
  Input,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ViewChild
} from '@angular/core';
import { GenericChartData } from '../chart-types';
import { ColorsGraphArray } from '../colors-graph';

@Component({
  selector: 'app-vertical-bar-chart-content',
  templateUrl: './vertical-bar-chart-content.component.html',
  styleUrls: ['./vertical-bar-chart-content.component.scss']
})
export class VerticalBarChartContentComponent implements AfterViewInit, OnDestroy {
  @Input() data: GenericChartData[] = [];
  @Input() label: string = '';
  @Input() sufix: string = '';
  @Input() classContent: string = '';
  @Input() showContent = true;

  @Input() view: any[] = [200, 220];
  @Input() yAxisTicks?: number[];
  @Input() showXAxis = true;
  @Input() showYAxis = false;
  @Input() gradient = false;
  @Input() showLegend = false;
  @Input() showXAxisLabel = false;
  @Input() xAxisLabel = '';
  @Input() showYAxisLabel = false;
  @Input() yAxisLabel = '';
  @Input() roundEdges = false;
  @Input() showMessageDataIsEmpty = true;
  @Input() customTooltip: boolean = false;
  @Input() tooltipLabel: string = '';
  @Input() isDouble: boolean = false;
  @Input() casasDecimais = 2;
  @Input() tooltipTitleIsName = true;
  @Input() extraCardClass: string = '';
  @Input() barPadding = 0;
  @Input() yScaleMin = 0;
  @Input() yScaleMax = 0;
  @Input() trimXAxisTicks = true;
  @Input() showDataLabel = false;
  @Input() chartId = '';
  @Input() legendPosition: string = 'right';
  @Input() legendTitle: string = '';
  @Input() colorScheme = {
    domain: [...ColorsGraphArray]
  };

  @ViewChild('containerRef', { static: false }) containerRef!: ElementRef;

  private resizeObserver!: ResizeObserver;

  ngAfterViewInit(): void {
    this.setupResizeObserver();
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private setupResizeObserver(): void {
    if (this.containerRef?.nativeElement) {
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const cr = entry.contentRect;
          this.resizeChart(cr.width, cr.height || 300);
        }
      });
      this.resizeObserver.observe(this.containerRef.nativeElement);
    }
  }

  resizeChart(width: number, height: number = 300): void {
    this.view = [width, height];
  }

  get dataIsEmpty(): boolean {
    return this.data?.every((x) => x.value === 0);
  }

  get showChartWithMessage(): boolean {
    if (!this.showMessageDataIsEmpty) return true;
    return !this.dataIsEmpty;
  }

  formatValueFn = (value) => this.isDouble ? `${value?.toFixed(this.casasDecimais)?.replace('.', ',')}${this.sufix}` : `${value}${this.sufix}`;
  tooltipTitle = (data: any) => this.tooltipTitleIsName ? data.name : this.tooltipLabel;

}
